import * as Ladda from 'ladda';

/**
 * Set global so you don't have to import it
 */
window.Ladda = Ladda;
